import React from "react";
import styled from 'styled-components';
import { Card, Heading } from "../../Components/StyledComponents/StyledComponents";

const Root = styled.div``;

const DataWrapper = styled.div`
  display:flex;
  justify-content:space-between;
  padding:${(p) => p.theme.spacing.xs};
  ${(p) => p.bgStyle ? `
    background-color:${p.theme.colors.lightvoiletColor};
    border-radius:${p.theme.radius.xl};
  ` : `
    padding:${p.theme.newspacing.xs} ${p.theme.spacing.xs};

  `}
`;
const Data = styled.div`
font-size:${(p) => p.theme.font.size.xs};
width:100px;
@media(min-width:1600px){
  width:150px;
  font-size:${(p) => p.theme.font.size.md};
}
`;

const LabelData = styled.div`
font-size:${(p) => p.theme.font.size.xs};
@media(min-width:1600px){
  font-size:${(p) => p.theme.font.size.md};
}

`;
const OnChainData = ({ nft }) => {
  return (
    <Root>
      <Heading bottom="sm">
        ON-CHAIN DATA
      </Heading>
      <Card>
        <DataWrapper bgStyle={true}>
          <LabelData>Owner</LabelData>
          <Data>{nft.ownerAddress.slice(0, 6)}...{nft.ownerAddress.slice(-4)}</Data>
        </DataWrapper>
        <DataWrapper bgStyle={false}>
          <LabelData>Contract address</LabelData>
          <Data>{nft.contractAddress.slice(0, 6)}...{nft.ownerAddress.slice(-4)}</Data>
        </DataWrapper>
        <DataWrapper bgStyle={true}>
          <LabelData>Token ID</LabelData>
          <Data>{nft.TokenId}</Data>
        </DataWrapper>
        <DataWrapper bgStyle={false}>
          <LabelData>Mining HashRate</LabelData>
          <Data>{nft.miningHashRate}</Data>
        </DataWrapper>
        <DataWrapper bgStyle={true}>
          <LabelData>Asset Protocol</LabelData>
          <Data>{nft.assetProtocol}</Data>
        </DataWrapper>
        <DataWrapper bgStyle={false}>
          <LabelData>Asset public chain</LabelData>
          <Data>{nft.assetPublicchain}</Data>
        </DataWrapper>
        <DataWrapper bgStyle={true}>
          <LabelData>Breed Count</LabelData>
          <Data>{nft.BreedCount}</Data>
        </DataWrapper>
      </Card>
    </Root>
  );
};

export default OnChainData;